"use strict";

var _slicedToArray = require("/codebuild/output/src602531421/src/masterbrews.cards/node_modules/@babel/runtime/helpers/slicedToArray.js");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnimatedQRCodePlayer = void 0;
var react_1 = __importStar(require("react"));
var rxjs_1 = require("rxjs");
var BaseQRCode_1 = require("../components/BaseQRCode");
var bc_ur_1 = require("@cvbb/bc-ur");
var events_1 = require("events");
var Button_1 = require("../components/Button");
var ButtonGroup_1 = require("../components/ButtonGroup");
var useAnimatedQRCodePlayer = function useAnimatedQRCodePlayer() {
  var _react_1$useState = react_1.useState([]),
    _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
    data = _react_1$useState2[0],
    setData = _react_1$useState2[1];
  var _react_1$useState3 = react_1.useState(500),
    _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
    refreshSpeed = _react_1$useState4[0],
    setRefreshSpeed = _react_1$useState4[1];
  var _react_1$useState5 = react_1.useState(false),
    _react_1$useState6 = _slicedToArray(_react_1$useState5, 2),
    hasNext = _react_1$useState6[0],
    setHasNext = _react_1$useState6[1];
  var _react_1$useState7 = react_1.useState(0),
    _react_1$useState8 = _slicedToArray(_react_1$useState7, 2),
    index = _react_1$useState8[0],
    setIndex = _react_1$useState8[1];
  var _react_1$useState9 = react_1.useState(null),
    _react_1$useState10 = _slicedToArray(_react_1$useState9, 2),
    title = _react_1$useState10[0],
    setTitle = _react_1$useState10[1];
  var _react_1$useState11 = react_1.useState(null),
    _react_1$useState12 = _slicedToArray(_react_1$useState11, 2),
    description = _react_1$useState12[0],
    setDescription = _react_1$useState12[1];
  var _react_1$useState13 = react_1.useState(false),
    _react_1$useState14 = _slicedToArray(_react_1$useState13, 2),
    isPause = _react_1$useState14[0],
    setPause = _react_1$useState14[1];
  var pause = function pause() {
    setPause(true);
  };
  var play = function play() {
    setPause(false);
  };
  var next = function next() {
    setIndex(function (index) {
      if (index >= splitArray.length - 1) {
        return 0;
      } else {
        return index + 1;
      }
    });
  };
  var prev = function prev() {
    setIndex(function (index) {
      if (index < 0) {
        return splitArray.length - 1;
      } else {
        return index - 1;
      }
    });
  };
  var ee = react_1.useMemo(function () {
    return new events_1.EventEmitter();
  }, []);
  var splitArray = data;
  var reset = function reset() {
    setData([]);
    setRefreshSpeed(500);
    setIndex(0);
  };
  react_1.useEffect(function () {
    if (!isPause) {
      var subscribe = rxjs_1.interval(refreshSpeed).subscribe(function () {
        next();
      });
      return function () {
        subscribe.unsubscribe();
      };
    }
  }, [refreshSpeed, splitArray, isPause]);
  var finish = function finish() {
    ee.emit('finish', true);
  };
  var element = react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, title && react_1.default.createElement("p", null, title), description && react_1.default.createElement("p", null, description), react_1.default.createElement(BaseQRCode_1.BaseQRCode, {
    size: 288,
    data: splitArray[index]
  }), react_1.default.createElement("p", {
    style: {
      textAlign: 'center'
    }
  }, index + 1, "/", splitArray.length), react_1.default.createElement(ButtonGroup_1.ButtonGroup, null, isPause ? react_1.default.createElement(Button_1.Button, {
    onClick: play
  }, "Play") : react_1.default.createElement(Button_1.Button, {
    onClick: pause
  }, "Pause"), react_1.default.createElement(Button_1.Button, {
    onClick: next
  }, "Next"), react_1.default.createElement(Button_1.Button, {
    onClick: prev
  }, "Prev")), react_1.default.createElement(ButtonGroup_1.ButtonGroup, null, react_1.default.createElement(Button_1.Button, {
    onClick: finish
  }, hasNext ? 'Next' : 'Finish')));
  return [element, {
    play: function play(data, options) {
      return new Promise(function (resolve) {
        var urs = bc_ur_1.encodeUR(data, 800);
        setData(urs);
        if (options) {
          options.refreshSpeed && setRefreshSpeed(options.refreshSpeed);
          options.hasNext && setHasNext(options.hasNext);
          options.title && setTitle(options.title);
          options.description && setDescription(options.description);
        }
        ee.once('finish', function () {
          reset();
          resolve();
        });
      });
    }
  }];
};
exports.useAnimatedQRCodePlayer = useAnimatedQRCodePlayer;